import { FC, useEffect, useState } from "react";
import { DocumentGridStateType } from "../../../@types/documents";
import { DefaultGrid } from "../../../components/grids/default/defaultGrid";
import { PluginWrapper, ToolbarWrapper } from "../../../components/plugins";
import useGridFilter, { DefaultDateGridFilter } from "../../../system/hooks/useGridFilter";
import { useAppContext } from "../../../system/providers/appContextProvider";
import styles from "../../styles/index.module.scss";
import { Spinner } from "../../../components/spiner/Spinner";
import { IFalsificatViewDTO } from "../../../libs/coreapi-dto/dirs/Falsificat";
import { FalsificatDataProvider } from "../../../Services/DataProviders/FalsificatDataProvider";
import { FalsificatPanel } from "./Components/FalsificatPanel";

export const FalsificatGridView: FC<IGridProps> = (props) => {
    const appContext = useAppContext();
    const cdp = new FalsificatDataProvider(appContext.coreApiService);
    const [gridFilter, dispatchGridFilter] = useGridFilter(DefaultDateGridFilter());    

    const [viewState, setViewState] = useState<DocumentGridStateType>("view");
    const [data, setData] = useState<IFalsificatViewDTO[]>([]);
    const [isSubmitting, setIsSubmitting] = useState<boolean>(true);
    const [totalCount, setTotalCount] = useState<number>(0);   

    const [selectedItem,setSelectedItem] = useState<IGridRow>();

    useEffect(() => {
        setIsSubmitting(true)
        cdp.getView(gridFilter, (entities, totalCount) => {
            setTotalCount(totalCount);
            setData(entities);
            setIsSubmitting(false)
            setViewState("view");
        });
    }, [viewState, gridFilter]);

    return (
        <>
            <PluginWrapper>
                <ToolbarWrapper>
                    <FalsificatPanel
                        gridFilter={gridFilter} 
                        dispatchGridFilter={dispatchGridFilter}
                        permission={props.plugin.permission}
                        isModal={props.isModal}
                        onFocusChanged={props.onFocusChanged}
                        refresh={{
                            onClick: () => {
                                setViewState("refresh");
                                setSelectedItem(undefined);
                            },
                        }}>                        
                    </FalsificatPanel>                    
                </ToolbarWrapper>

                <div className={styles.gridWrapper}>
                    <div className={styles.masterGrid}>
                        {isSubmitting ? (
                            <Spinner />
                        ) :
                            <DefaultGrid
                                showQuantity
                                gridId={props.gridId}
                                data={data}
                                filter={gridFilter}
                                totalCount={totalCount}
                                separator
                                typeDictionaries
                                dataProvider={cdp}                                
                                plugin={props.plugin}
                                selectedItem={selectedItem}
                                multipleSelect={props.multipleSelect}
                                onSelect={() => {}}
                                onSort={(i) => dispatchGridFilter({ type: "sort", payload: i.propertyName })}
                                onFilterDelete={(i) => {}}
                                onPageNumberChange={(n) => dispatchGridFilter({ type: "changePageNumber", payload: { pageNumber: n } })}
                                onNumberPerPageChange={(n) => dispatchGridFilter({ type: "changeNumberPerPage", payload: { numberPerPage: n } })}
                            />}
                    </div>                   
                </div>
            </PluginWrapper>
        </>
    );
};